export default class OrganizationAppCU {
  constructor(API) {
    this.api = API;
  }
  /* CRUD */
  async getOrganizationAppCU(orgID, cuID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/organization/' + orgID + '/app/cu/' + cuID;
    return await req.exec();
  }
  async removeOrganizationAppCU(orgID, cuID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = '/organization/' + orgID + '/app/cu/' + cuID;
    return await req.exec();
  }
  async createOrganizationAppCU(orgID, cuID) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/organization/' + orgID + '/app/cu/' + cuID;
    // req.body = { ...cuObj };
    return await req.exec();
  }
  async updateOrganizationAppCU(orgID, cuID) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = '/organization/' + orgID + '/app/cu/' + cuID;
    // req.body = { ...updateObj };
    return await req.exec();
  }
  /* List */
  async getAllOrganizationAppCUs(orgID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/organization/${orgID}/app/cus`;
    return await req.exec();
  }
}
